import { gtag } from 'ga-gtag'

export default {
  methods: {
    trackEvent(action, message, options = {}) {
      gtag(action, message, options)
    }
  }
}